var DataViewType;
(function (DataViewType) {
    DataViewType[DataViewType["Customers"] = 1] = "Customers";
    DataViewType[DataViewType["Leads"] = 2] = "Leads";
    DataViewType[DataViewType["Logs"] = 3] = "Logs";
})(DataViewType || (DataViewType = {}));
export default DataViewType;
